import React from "react";

// packages
import parse from "html-react-parser";

// util
import { convertToRoman } from "utils/convertToRoman";
import { numberToAlifNumerals, numberToArabicNumerals } from "utils/Helper";

export const SindhiLongQuestions = ({
  data,
  is10,
  subject_id,
  startIndex,
  class_id,
  isMcqExist,
}) => {
  const startingQuestionNumber = isMcqExist ? 2 : 1;
  let i = 0;
  return (
    <div>
      {data?.paperLongQuestions?.map((ele, index) => {
        return (
          <div key={index} className="mb-3 noto-nastaliq-sindhi">
            {ele.ui_style == "" && (
              <>
                <div className={`row text-right clearfix mb-2  `}>
                  <div className="col-10 d-flex">
                    <span>
                      سوال
                      {index + startIndex + startingQuestionNumber}:{" "}
                    </span>
                    {ele?.question_ids?.map((ques, index) => {
                      return (
                        <>
                          <span>{parse(`${ques.question}`)}</span>
                        </>
                      );
                    })}
                  </div>
                  <div className="col-2  ">{ele.marks}</div>
                </div>
              </>
            )}
            {ele.ui_style == "bullet" && (
              <>
                <div className={`row text-right clearfix mb-2  `}>
                  <div className="col-10 d-flex">
                  {console.log("LONG ELE:")}
                  {console.log(ele)}
                    <span>
                      سوال
                      {(index + startingQuestionNumber) == 3 ? (index + startingQuestionNumber) + 4 :
                      index + startingQuestionNumber}:{" "}
                    </span>
                    {ele?.question_ids?.map((ques, index) => {
                      return (
                        <>
                          <span>{parse(`${ques.question}`)}</span>
                        </>
                      );
                    })}
                  </div>
                  <div className="col-2  ">{ele.marks}</div>
                </div>
              </>
            )}
            {ele.ui_style == "bullet_with_question" && (
              <>
                <div className={`row text-right clearfix mb-2  `}>
                  <div className="col-10 d-flex" style={{ flexDirection: "column" }}>
                    {console.log("LONG ELE:")}
                    {console.log(ele)}
                    {/* <span className="d-flex">
                      سوال
                      {index + startingQuestionNumber}:{" "}
                      {ele?.text}
                    </span> */}
                    { ele?.text.includes(" الف ") ? 
                  <>
                    <span className="d-flex">
                        سوال { ele?.text.includes("سبق جو خلاصو") ? (index + startingQuestionNumber) + 2 : 
                        (index + startingQuestionNumber)}:{" "}
                        {ele?.text}
                        </span>
                    </>
                    : ele?.text.includes(" ب ") ? ele?.text
                      // ((index - 1) + startingQuestionNumber) 
                      : ele?.text.includes(" ج ") ? ele?.text 
                      // ((index - 2) + startingQuestionNumber)
                      : <>
                        <span>
                        سوال {(index + startingQuestionNumber)}
                        </span>:{" "}
                        {ele?.text}
                      </>}
                    <span className="d-flex flex-col" style={{ gap: "20px" }}>
                    {ele?.question_ids?.map((ques, index) => {
                      return (
                        <>
                          <span>{parse(`${ques.question}`)}</span>
                        </>
                      );
                    })}
                    </span>
                  </div>
                  <div className="col-2  ">{ele.marks}</div>
                </div>
              </>
            )}
            {ele.ui_style == "يا" && (
              <>
                <div className={`row text-right clearfix mb-2  `}>
                <div className="col-12 text-center">
                          <span>۔۔۔۔۔۔یا۔۔۔۔۔</span>
                  </div>
                  <div className="col-10 d-flex">
                    {/* <span>
                      سوال
                      {index + startingQuestionNumber}:{" "}
                    </span> */}
                    {ele?.question_ids?.map((ques, index) => {
                      return (
                        <>
                          <span>{parse(`${ques.question}`)}</span>
                        </>
                      );
                    })}
                  </div>
                  {/* <div className="col-2  ">{ele.marks}</div> */}
                </div>
              </>
            )}
            {ele.ui_style == "bullet_romen" && (
              <>
                <div className={`row text-right clearfix mb-2 `}>
                  <div className="col-10 ">
                    <span>
                      سوال
                      {ele?.text?.includes?.("مضمون") ? ((index - 4) + startIndex + startingQuestionNumber)
                      : (index + startIndex + startingQuestionNumber) == 13 ?
                      (index + startIndex + startingQuestionNumber) - 5 :
                      (index + startIndex + startingQuestionNumber)}: 
                    </span>
                    {ele.text}
                  </div>
                  <div className="col-2  ">{ele.marks}</div>
                </div>

                {ele?.question_ids?.map((ques, index) => {
                  return (
                    <>
                      <p
                        className="col-12"
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          margin: 0,
                        }}
                      >
                        <span
                          style={{ marginRight: "5px", fontWeight: "bold" }}
                        >
                          {`(${convertToRoman(index + 1)}).`}
                        </span>
                        <span>{parse(`${ques.question}`)}</span>
                      </p>
                    </>
                  );
                })}
              </>
            )}
            {ele.ui_style == "bullet_alif" && (
              <>
                <div className={`row text-right clearfix mb-2 `}>
                  <div className="col-1 ">
                    <span>
                      سوال
                      {index + startIndex + startingQuestionNumber}:
                    </span>
                  </div>
                  <div className="col-9 ">
                    {ele?.question_ids?.map((ques, index) => {
                      return (
                        <p
                          // className="col-12"
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            margin: 0,
                          }}
                        >
                          <span
                            style={{ marginRight: "5px", fontWeight: "bold" }}
                          >
                            {`(${numberToAlifNumerals(index + 1)}).`}
                          </span>
                          <span>{parse(`${ques.question}`)}</span>
                        </p>
                      );
                    })}
                  </div>
                  <div className="col-2  ">{ele.marks}</div>
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export const SindhiShortQuestions = ({
  data,
  subject_id,
  class_id,
  isMcqExist,
}) => {
  const startingQuestionNumber = isMcqExist ? 2 : 1;
  return (
    <div>
      {data?.paperShortQuestions?.map((ele, index) => {
        return (
          <div key={index} className="mb-3 noto-nastaliq-sindhi">
            {ele.ui_style == "" && (
              <>
                <div className={`row text-right clearfix mb-2  `}>
                  <div className="col-10 d-flex">
                      {ele?.text.includes(" ب ") ? ''
                      // ((index - 1) + startingQuestionNumber) 
                      : ele?.text.includes(" ج ") ? '' 
                      // ((index - 2) + startingQuestionNumber)
                      : ele?.text.includes(" د ") ? ''
                      // ((index - 3) + startingQuestionNumber)
                      : <>
                        <span>
                        سوال {(index + startingQuestionNumber) == 8 ? ((index - 3) + startingQuestionNumber)
                        : (index + startingQuestionNumber)}
                        </span>:{" "}
                      </>}
                    {console.log("ELE:")}
                    {console.log(ele)}
                    {ele?.text}
                  </div>
                  <div className="col-2  ">{ele.marks}</div>
                </div>
                <div className="d-flex col-10" style={{ gap: "24px" }}>
                  {ele?.sq_question_ids?.map((ques, index) => {
                    return (
                      <>
                        <span>{parse(`${ques.question}`)}</span>
                      </>
                    );
                  })}
                </div>
              </>
            )}
            {ele.ui_style == "يا" && (
              <>
                <div className={`row text-right clearfix mb-2  `}>
                <div className="col-12 text-center">
                          <span>۔۔۔۔۔۔یا۔۔۔۔۔</span>
                  </div>
                  <div className="col-10 d-flex" style={ ele?.text?.includes?.("سوالن") ? { flexDirection: "column" } : {} }>
                    {ele?.text?.includes?.("سوالن") ? <>
                      {/* <span>
                      سوال
                      {index + startingQuestionNumber}:{" "}
                    </span> */}
                    {ele?.text}
                    </> : '' } 
                    {ele?.sq_question_ids?.map((ques, index) => {
                      return (
                        <>
                          <span>{parse(`${ques.question}`)}</span>
                        </>
                      );
                    })}
                  </div>
                  {/* <div className="col-2  ">{ele.marks}</div> */}
                </div>
              </>
            )}
            {ele.ui_style == "bullet" && (
              <>
                <div className={`row text-right clearfix mb-2  `}>
                  <div className="col-10 d-flex">
                    <span>
                      سوال
                      {index + startingQuestionNumber}:{" "}
                    </span>
                    {ele?.sq_question_ids?.map((ques, index) => {
                      return (
                        <>
                          <span>{parse(`${ques.question}`)}</span>
                        </>
                      );
                    })}
                  </div>
                  <div className="col-2  ">{ele.marks}</div>
                </div>
              </>
            )}
            {ele.ui_style == "bullet_romen" && (
              <>
                <div className={`row text-right clearfix mb-2 `}>
                  <div className="col-10 ">
                    <span>
                      سوال
                      {index + startingQuestionNumber}:
                    </span>
                    {ele.text}
                  </div>
                  <div className="col-2  ">{ele.marks}</div>
                </div>

                {ele?.sq_question_ids?.map((ques, index) => {
                  return (
                    <>
                      <p
                        className="col-12"
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          margin: 0,
                        }}
                      >
                        <span
                          style={{ marginRight: "5px", fontWeight: "bold" }}
                        >
                          {`(${convertToRoman(index + 1)}).`}
                        </span>
                        <span>{parse(`${ques.question}`)}</span>
                      </p>
                    </>
                  );
                })}
              </>
            )}
            {ele.ui_style == "bullet_alif" && (
              <>
                <div className={`row text-right clearfix mb-2 `}>
                  <div className="col-1 ">
                    <span>
                      سوال
                      {index + startingQuestionNumber}:
                    </span>
                  </div>
                  <div className="col-9 ">
                    {ele?.sq_question_ids?.map((ques, index) => {
                      return (
                        <p
                          // className="col-12"
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            margin: 0,
                          }}
                        >
                          <span
                            style={{ marginRight: "5px", fontWeight: "bold" }}
                          >
                            {`(${numberToAlifNumerals(index + 1)}).`}
                          </span>
                          <span>{parse(`${ques.question}`)}</span>
                        </p>
                      );
                    })}
                  </div>
                  <div className="col-2  ">{ele.marks}</div>
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};
